module.exports = __webpack_public_path__ + "fonts/SourceSansPro-SemiBold.c1b4f417.ttf";